<template>
  <div class="mb-4">
    <div
      class="d-flex flex-column flex-md-row justify-space-between align-md-center mb-3"
      style="gap: 16px"
    >
      <div>
        <h1 class="text-h5 font-weight-bold mb-1">{{ titulo }}</h1>
        <p v-if="subtitulo" class="text-body-2 text-muted mb-0">
          {{ subtitulo }}
        </p>
      </div>
      <div
        v-if="$slots.acciones"
        class="d-flex flex-wrap align-center"
        style="gap: 12px"
      >
        <slot name="acciones"></slot>
      </div>
    </div>

    <v-card
      v-if="conBusqueda || $slots.filtros"
      variant="outlined"
      class="pa-2"
    >
      <v-card-text
        class="d-flex flex-wrap align-center py-2"
        style="gap: 16px"
      >
        <v-text-field
          v-if="conBusqueda"
          :model-value="busqueda"
          @update:model-value="$emit('update:busqueda', $event)"
          prepend-inner-icon="mdi-magnify"
          :label="placeholderBusqueda"
          variant="outlined"
          density="comfortable"
          hide-details
          clearable
          style="max-width: 320px; min-width: 220px; flex: 1 1 220px"
        ></v-text-field>

        <slot name="filtros"></slot>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "EncabezadoFiltros",

  props: {
    titulo: { type: String, required: true },
    subtitulo: { type: String, default: "" },
    busqueda: { type: String, default: "" },
    placeholderBusqueda: { type: String, default: "Buscar" },
    conBusqueda: { type: Boolean, default: true },
  },

  emits: ["update:busqueda"],
};
</script>
